import { MapUtils } from "../../../../core/MapUtils";
export var PolySceneEventType = /* @__PURE__ */ ((PolySceneEventType2) => {
  PolySceneEventType2["LOADED"] = "sceneLoaded";
  PolySceneEventType2["PLAY"] = "play";
  PolySceneEventType2["PAUSE"] = "pause";
  return PolySceneEventType2;
})(PolySceneEventType || {});
export const ACCEPTED_SCENE_EVENT_TYPES = [
  "sceneLoaded" /* LOADED */,
  "play" /* PLAY */,
  "pause" /* PAUSE */
];
export class PolySceneEvent extends Event {
  constructor(type) {
    super(type);
  }
  get type() {
    return super.type;
  }
}
export const SCENE_EVENT_LOADED_EVENT_CONTEXT = {
  event: new PolySceneEvent("sceneLoaded" /* LOADED */)
};
export const SCENE_EVENT_PLAY_EVENT_CONTEXT = {
  event: new PolySceneEvent("play" /* PLAY */)
};
export const SCENE_EVENT_PAUSE_EVENT_CONTEXT = {
  event: new PolySceneEvent("pause" /* PAUSE */)
};
export class SceneEventsController {
  constructor() {
    this._observersByEventType = /* @__PURE__ */ new Map();
  }
  dispatch(eventContext) {
    const event = eventContext.event;
    if (!event) {
      return;
    }
    const set = this._observersByEventType.get(event.type);
    if (!set) {
      return;
    }
    set.forEach((node) => {
      node.processEvent(eventContext);
    });
  }
  removeObserverFromAllEventTypes(eventNode) {
    this._observersByEventType.forEach((nodes, eventType) => {
      nodes.delete(eventNode);
    });
  }
  addObserver(eventNode, eventType) {
    MapUtils.addToSetAtEntry(this._observersByEventType, eventType, eventNode);
  }
}
